module.exports = __webpack_public_path__ + "static/media/ges.eb19096f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/ges.png
// module id = 52
// module chunks = 0